import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { toUserId } from '../../common/utils/ari';
import { DEFAULT_CONFIG } from '../constants';
import { BaseGraphQlClient } from '../graphql-client';
import { logException } from '../sentry/main';
import TeamMembershipsQuery from './utils/queries/team-membership-query';
import { TeamsUserQuery } from './utils/queries/user-query';
import { toUserType } from './utils/user-type';
export var AGGClient = /*#__PURE__*/function (_BaseGraphQlClient) {
  _inherits(AGGClient, _BaseGraphQlClient);
  var _super = _createSuper(AGGClient);
  function AGGClient(baseUrl, config) {
    _classCallCheck(this, AGGClient);
    return _super.call(this, "".concat(baseUrl, "/graphql"), config);
  }
  _createClass(AGGClient, [{
    key: "setBaseUrl",
    value: function setBaseUrl(baseUrl) {
      this.setServiceUrl("".concat(baseUrl, "/graphql"));
    }
  }, {
    key: "queryTeamMemberships",
    value: function () {
      var _queryTeamMemberships = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(teamId) {
        var membershipState,
          pageInfo,
          response,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              membershipState = _args.length > 1 && _args[1] !== undefined ? _args[1] : ['FULL_MEMBER'];
              pageInfo = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
                first: 100
              };
              _context.next = 4;
              return this.makeGraphQLRequest({
                query: TeamMembershipsQuery,
                variables: _objectSpread({
                  teamId: teamId,
                  membershipState: membershipState,
                  siteId: this.getCloudId()
                }, pageInfo)
              }, {
                operationName: 'TeamMembership'
              });
            case 4:
              response = _context.sent;
              return _context.abrupt("return", {
                edges: response.team.teamV2.members.edges.map(function (_ref) {
                  var _node$member$extended, _node$member$extended2;
                  var node = _ref.node;
                  return {
                    membershipId: {
                      teamId: teamId,
                      memberId: toUserId(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                      id: toUserId(node.member.id),
                      fullName: node.member.name,
                      avatarUrl: node.member.picture,
                      status: node.member.accountStatus,
                      title: (_node$member$extended = (_node$member$extended2 = node.member.extendedProfile) === null || _node$member$extended2 === void 0 ? void 0 : _node$member$extended2.jobTitle) !== null && _node$member$extended !== void 0 ? _node$member$extended : undefined,
                      userType: toUserType({
                        appType: node.member.appType
                      })
                    }
                  };
                }),
                pageInfo: response.team.teamV2.members.pageInfo
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function queryTeamMemberships(_x) {
        return _queryTeamMemberships.apply(this, arguments);
      }
      return queryTeamMemberships;
    }()
  }, {
    key: "queryAGGUser",
    value: function () {
      var _queryAGGUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.makeGraphQLRequest({
                query: TeamsUserQuery,
                variables: {
                  userId: userId
                }
              }, {
                operationName: 'TeamsUserQuery'
              });
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", response.user);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function queryAGGUser(_x2) {
        return _queryAGGUser.apply(this, arguments);
      }
      return queryAGGUser;
    }()
  }]);
  return AGGClient;
}(BaseGraphQlClient);
export var aggClient = new AGGClient(DEFAULT_CONFIG.stargateRoot, {
  logException: logException
});